import { AfterViewInit, Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA } from '@angular/material/dialog'
import events from '../../../tagging/events'
import { TaggingService } from '../../../tagging/tagging.service'
import { DialogData } from '../../ui.types'
import { ConfigService } from '../../../config/config.service'
import { Router } from '@angular/router'
import { getRapAppId } from '../../../../shared/utils/branding'

@Component({
  selector: 'app-invalid-membership',
  templateUrl: './invalid-membership.component.html',
  styleUrls: ['../shared-dialog.component.scss'],
})
export class InvalidMembershipComponent implements AfterViewInit {
  pageType = events.shared.CALL_AAA_PAGE_TYPE

  isRapUser = (() => Boolean(getRapAppId()))()

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private taggingService: TaggingService,
    private configService: ConfigService,
    private router: Router,
  ) {}

  ngAfterViewInit(): void {
    this.taggingService.setPageEvent(
      events.shared.CALL_AAA_PROMPT,
      events.shared.CALL_AAA_PAGE_TYPE
    )
    this.taggingService.setPageLoadEvent({
      pageName: events.shared.CALL_AAA_PROMPT
    })
  }

  ngOnInit() {
  }

  onClose() {
    if (this.configService.getConfig().nativeAppView) {
      this.router.navigate([this.configService.getConfig().homeBackButtonRedirectTo], { replaceUrl: true })
    } else {
      this.data.close()
    }
  }

  onCallAAAClick() {
    this.data.close()
  }
}
